<section class="lg:flex md:sm:grid md:sm:grid-cols-1 gap-4">
    <article class="lg:flex rounded h-10">
      <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    <article class="relative lg:flex box rounded" (click)="filterOpened = !filterOpened">
      <button id="buttonOpenFilter" 
        class="text-gray-800 font-bold py-2 px-2 rounded inline-flex items-center"
        [ngClass]="{ 'opened' : filterOpened, 'filtersApplied': filtersApplied > 0  }">
        <img [src]="images.filter" alt="filter" class="w-6 h-6" [ngClass]="{ 'filterOpened': filterOpened || filtersApplied > 0 }" />
      </button>
      @if (filtersApplied > 0) {
        <div class="filter-bubble w-4 h-4 absolute -top-2 -right-2 flex justify-center items-center p-[10px] rounded-full text-xs font-bold">
          {{ filtersApplied }}
        </div>
      }
    </article>
    <article class="flex absolute mt-15 ml-0 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !filterOpened }">
      <app-trip-filter (filter)="filter.emit($event); updateFilters()" (closeFilter)="filterOpened = false; updateFilters()" [componentOpen]="'buttonOpenFilter'" [isFilterOpen]="filterOpened"></app-trip-filter>
    </article>
    @if (searching) {
      <article class="flex items-center pb-2">
        <img [src]="images.loading" alt="loading" class="h-10 w-10 ml-4" />
        <label class="font-semibold text-base ml-4">{{ literalService.get('trips.searchingTrips', true) }}...</label>
      </article>
    }
    <!-- <article id="sort" class="lg:flex lg:mr-4 rounded mb-2" (click)="sortedOpened = !sortedOpened">
      <button id="buttonOpenSort" 
        class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
      >
        <img [src]="images.sort" alt="sort" class="w-6 h-6 mr-2" />
        <span class="font-semibold text-base">{{
          literalService.get("users.sort", true)
        }}</span>
      </button>
    </article> -->
    <!-- <article id="sortModal" class="flex absolute mt-20 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !sortedOpened }">
      <app-sort (closeSort)="sortedOpened = false" (sort)="sort.emit()" [componentOpen]="'buttonOpenSort'"></app-sort>
    </article> -->
    <!-- <article class="lg:flex lg:mr-4 rounded mb-2">
      <button class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
        <img [src]="images.visibilityOff" alt="visibilityOff" class="w-6 h-6 mr-2"/>
        <span class="font-normal">{{ literalService.get("users.manageColumns", true) }}</span>
      </button>
    </article>
    <article class="lg:flex lg:mr-4 rounded mb-2 inline-flex items-center">
      <img [src]="images.download" alt="download" class="w-8 h-8 mr-2" />
    </article> -->
  </section>
  